// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".VariantSelector-module-container-B6mXH{display:flex;justify-content:center;align-items:center;width:16px;min-width:16px;height:16px;border-radius:50%}.VariantSelector-module-radio-RMlU7{display:block;width:16px;height:16px;border-radius:50%;box-shadow:0 0 0 1px #c7c7c7;box-shadow:0 0 0 1px var(--colorSelector-dotBorder, #c7c7c7)}", ""]);
// Exports
exports.locals = {
	"container": "VariantSelector-module-container-B6mXH",
	"radio": "VariantSelector-module-radio-RMlU7"
};
module.exports = exports;
